import { Box } from '@mui/material';
import SecondBrainExperience from '@/features/secondBrain/SecondBrainExperience';

const SecondBrainPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: 'calc(100vh - 56px)', // Fill viewport minus navbar
      }}
    >
      <SecondBrainExperience />
    </Box>
  );
};

export default SecondBrainPage;
